import incentives from './incentives';
import account from './account';
import modal from './modal';
import widgetInfo from './widgetInfo';
import vcdaError from './vcdaError';

const root = {
	incentives,
	account,
	modal,
	widgetInfo,
	vcdaError
};

export default root;



// WEBPACK FOOTER //
// ./src/reducers/index.js